import { LogLevel } from '@azure/msal-browser';

// Config object to be passed to Msal on creation.
// For a full list of msal.js configuration parameters,
// visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
        authority: "https://login.microsoftonline.com/96b9695c-4f0e-42bd-8adf-ba755760346b",
        //redirectUri: redirectUri, //only change if you don't want the current page used
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored. SSO between browser tabs is only supported with localStorage
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        //console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        console.log("Hit the default in loggerCallback switch: ", message);
                }
            },
            piiLogginEnabled: false
        },
        // windowHashTimeout: 60000,
        // iframeHashTimeout: 6000,
        // loadFrameTimeout: 0,
        // asyncPopups: false
    }
};


// Add here the scopes to request when obtaining an access token for downstream API
const tokenRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE],
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};

export { msalConfig, tokenRequest };